var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPhone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 20 22",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "053326A9-D15E-4858-ACD5-3B1D02B2DF94")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-all-2020",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CustomerPage_Account_open_V1",
    transform: "translate(-45.000000, -346.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(46.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    strokeLinecap: "square",
    transform: "translate(14.500000, 4.500000) rotate(-180.000000) translate(-14.500000, -4.500000) ",
    points: "17.5357666 2.04545455 19 2.04545455 19 9 10 9 10 2.04545455 13.3010626 2.04545455 15.2885742 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.202,4.6846 L2.202,4.6846 C-0.734,7.6326 -0.734,12.4136 2.202,15.3616 L4.619,17.7886 C7.556,20.7376 12.316,20.7376 15.252,17.7886 L11.391,13.9116 L10.235,15.0726 C9.168,16.1436 7.439,16.1436 6.372,15.0726 L4.908,13.6016 C3.841,12.5306 3.841,10.7936 4.908,9.7236 L6.064,8.5626 L2.202,4.6846 Z",
    id: "Stroke-3"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone.93ffb85b.svg";
export { ForwardRef as ReactComponent };